import { render, staticRenderFns } from "./TypeSetting.vue?vue&type=template&id=160a125c&"
import script from "./TypeSetting.vue?vue&type=script&lang=js&"
export * from "./TypeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports